import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'genera-PK',
    initialState: {
        product_key: '',
        statusAction: 'READY',
    },
    actions: ['GEN_PK'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {

            case types.GEN_PK_SUCCESS:
                return {
                    ...state,
                    product_key: action.payload.product_key
                };

            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        //genPK
        genPKRequest: () => ({ type: types.GEN_PK_REQUEST }),
        genPKSuccess: ({ product_key }) => ({
            type: types.GEN_PK_SUCCESS,
            payload: { product_key },
        }),
        genPKFailed: error => ({ type: types.GEN_PK_FAILED, error: true, payload: { error } }),
    }),
});
